import { styled, component, hexToRgba } from '../../../utils/style';
import { Format, StyleColor } from '../../../utils/styles-constants';
import { HeaderSectionPosition } from './Section';

export const StyledHeader = styled()(component.div, 'StyledHeader')`
	position: absolute;
	right: 0;
	left: 0;
	z-index: 5;
	display: flex;
	box-sizing: border-box;
	padding: 0 15px;
	width: 100%;
	height: 44px;
	border: 0;
	border-bottom: 1px solid ${StyleColor.Grey100};
	background-color: ${props => {
		const opacity = props.theme.primary.topnavOpacity ? props.theme.primary.topnavOpacity : 100;
		return hexToRgba(props.theme.primary.topnavColor, opacity);
	}};
	align-items: center;

	> * {
		flex-grow: 1;
		flex-basis: 33%;
	}

	@media ${Format.Smartphone}, ${Format.Tablet} {
		padding: 0 5px;
	}
`;

interface StyledHeaderSectionProps {
	position: HeaderSectionPosition;
}

export const StyledHeaderSection = styled<StyledHeaderSectionProps>()(component.div, 'StyledHeaderSection') `
	flex-grow: 1;
	flex-basis: 33%;
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	${props => {
		switch (props.position) {
			case HeaderSectionPosition.Left:
				return (
					`justify-content: flex-start;
					margin-left: 5px;`);
			case HeaderSectionPosition.Center:
				return `justify-content: center;`;
			case HeaderSectionPosition.Right:
				return (
					`justify-content: flex-end;
					margin-right: 5px;`);
		}
	}}
`;

export const PageTitle = styled()(component.div, 'PageTitle') `
	display: flex;
	justify-content: center;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/styles.ts